module.exports = __webpack_public_path__ + "img/ch.30b54a5b.png";